import { Button, Icon, Modal, Text } from '../../common/components';
import { t } from '../../common/i18n';

const namespace = 'OtherServices';

interface VerifiedPartnerModalProps {
  isShown: boolean;
  onHide: () => void;
}

/** Vysvětlení štítku „Prověřený partner eVlastníci" – co si pod ním má předseda představit. */
export const VerifiedPartnerModal: React.FC<VerifiedPartnerModalProps> = ({ isShown, onHide }) => {
  const items = t('Verified.items', namespace, { returnObjects: true }) as unknown as string[];

  return (
    <Modal isShown={isShown} onHide={onHide} size="small">
      <div className="VerifiedPartnerModal">
        <div className="VerifiedPartnerModal__icon">
          <Icon name="shieldCheck" />
        </div>
        <Text size="h2" align="center" className="mb-2">
          {t('Verified.title', namespace)}
        </Text>
        <Text size="body-medium" color="Neutral700" align="center" className="mb-3">
          {t('Verified.intro', namespace)}
        </Text>
        <ul className="VerifiedPartnerModal__list">
          {items.map((item) => (
            <li key={item}>
              <Icon name="checkmark" />
              <Text as="span" size="body-medium" color="Neutral750">
                {item}
              </Text>
            </li>
          ))}
        </ul>
        <Button title={t('Verified.close', namespace)} wide onClick={onHide} />
      </div>
    </Modal>
  );
};

export default VerifiedPartnerModal;
